/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { UserDto } from './user-dto';

/**
 * 
 * @export
 * @interface GetActivityResponseDto
 */
export interface GetActivityResponseDto {
    /**
     * Activity ID
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'id': string;
    /**
     * Creation date in UTC
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'createdAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'updatedAt': string;
    /**
     * Last update date in UTC
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'deletedAt': string;
    /**
     * Name of the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'name': string;
    /**
     * Description of the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'description'?: string;
    /**
     * External source ID for the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'sourceId'?: string;
    /**
     * External source external ID for the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'sourceExternalId'?: string;
    /**
     * Source of the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'source': GetActivityResponseDtoSourceEnum;
    /**
     * Distance covered in meters
     * @type {number}
     * @memberof GetActivityResponseDto
     */
    'distance': number;
    /**
     * Duration of activity in seconds
     * @type {number}
     * @memberof GetActivityResponseDto
     */
    'duration': number;
    /**
     * Type of activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'type': GetActivityResponseDtoTypeEnum;
    /**
     * ActivityDate date in UTC
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'activityDate': string;
    /**
     * User ID who performed the activity
     * @type {string}
     * @memberof GetActivityResponseDto
     */
    'userId': string;
    /**
     * Array of image URLs associated with this activity
     * @type {Array<string>}
     * @memberof GetActivityResponseDto
     */
    'imageUrls'?: Array<string>;
    /**
     * Array of participation IDs that this activity was submitted to
     * @type {Array<string>}
     * @memberof GetActivityResponseDto
     */
    'participationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was approved for
     * @type {Array<string>}
     * @memberof GetActivityResponseDto
     */
    'approvedParticipationRecords': Array<string>;
    /**
     * Array of participation IDs that this activity was declined for
     * @type {Array<string>}
     * @memberof GetActivityResponseDto
     */
    'declinedParticipationRecords': Array<string>;
    /**
     * User who performed the activity
     * @type {UserDto}
     * @memberof GetActivityResponseDto
     */
    'user': UserDto;
}

export const GetActivityResponseDtoSourceEnum = {
    Strava: 'strava',
    Garmin: 'garmin',
    Manual: 'manual',
    AppleHealth: 'apple_health'
} as const;

export type GetActivityResponseDtoSourceEnum = typeof GetActivityResponseDtoSourceEnum[keyof typeof GetActivityResponseDtoSourceEnum];
export const GetActivityResponseDtoTypeEnum = {
    Run: 'run',
    Bike: 'bike',
    Swim: 'swim'
} as const;

export type GetActivityResponseDtoTypeEnum = typeof GetActivityResponseDtoTypeEnum[keyof typeof GetActivityResponseDtoTypeEnum];


